import { p as promiseResolve, b as bootstrapLazy } from './index-3ce1ac91.js';

/*
 Stencil Client Patch Esm v2.5.2 | MIT Licensed | https://stenciljs.com
 */
var patchEsm = function patchEsm() {
  return promiseResolve();
};
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-youtube", [[1, "deckgo-youtube", {
      "src": [1],
      "width": [2],
      "height": [2],
      "frameTitle": [1, "frame-title"],
      "allowFullscreen": [4, "allow-fullscreen"],
      "instant": [4],
      "loading": [32],
      "loaded": [32],
      "updateIFrame": [64],
      "lazyLoadContent": [64],
      "play": [64],
      "pause": [64]
    }]]]], options);
  });
};
export { defineCustomElements };